import { parse } from 'query-string';
import { DEP_CH_03, DEP_SV_05 } from '@upgrade/ui-utils/constants/program-definition-code';
import { PREMIER_SAVINGS_PATH } from '../constants/path-constants';

const RedirectParam = {
  FUNNEL_REDIRECT: 'funnel',
  LOGIN_REDIRECT: 'login'
};

/*
 * @param {object} location - location object from react-router
 * @param {string} leadUuid - user parameter to be appended to the URL
 * @param {object} extraParams - extra parameters to be appended to the URL with key-value pairs that will be converted to query string
 * @returns {string} - deposit URL
 */
export const getDepositUrl = ({ location, leadUuid = '', extraParams = {} }) => {
  const { search = '' } = location || {};
  const { redirect } = parse(search) || {};
  const pdc = location?.pathname.includes(PREMIER_SAVINGS_PATH) ? DEP_SV_05 : DEP_CH_03;
  const userParameter = leadUuid?.length ? `&user=${leadUuid}` : '';

  const extraParamsString = extraParams
    ? Object.entries(extraParams)
        .map(([key, value]) => `&${key}=${encodeURIComponent(value)}`)
        .join('')
    : '';

  if (redirect === RedirectParam.FUNNEL_REDIRECT) {
    return `/deposit/?pdc=${pdc}${userParameter}${extraParamsString}`;
  }

  if (!leadUuid?.length && redirect === RedirectParam.LOGIN_REDIRECT) {
    return `/portal/login-deposit-user?pdc=${pdc}`;
  }

  return `/deposit/?pdc=${pdc}${userParameter}${extraParamsString}`;
};

export const getPersonalLoansUrl = (leadUuid = '') => {
  if (!leadUuid?.length) {
    return `/funnel/personal-information-1`;
  }

  return `/funnel/check-lead/${leadUuid}`;
};

// map ctaLink address based on dynamic localStorage values (i.e. users who already logged in)
export const mapDepositLinks = (items = [], location) => {
  return (
    items?.filter(Boolean).map(item => {
      if (item.ctaLink?.startsWith('/deposit/')) {
        // eslint-disable-next-line no-param-reassign
        item.ctaLink = getDepositUrl({ location });
      }

      return item;
    }) ?? []
  );
};
